// extracted by mini-css-extract-plugin
export default {"root":"LongTextModal_root__DPb9Q","body":"LongTextModal_body__BYzeO"};